export default function translate(i18n, propriete) {
  if (propriete.indexOf('remisesBancaires') === 0 && propriete.indexOf('DomiciliationBancaireId') !== -1) {
    return i18n.t('listeEcheancePaiement.popUpCreationRemiseBancaire.banque');
  }
  if (propriete.indexOf('remisesBancaires') === 0 && propriete.indexOf('ModeReglementId') !== -1) {
    return i18n.t('isteEcheancePaiement.popUpCreationRemiseBancaire.nombreReglement');
  }
  if (propriete === 'dateRemise') {
    return i18n.t('listeEcheancePaiement.popUpCreationRemiseBancaire.dateRemise');
  }
  return propriete;
}
